import state from './state';

export default {
  logo() {
    return state.logo ? `${process.env.VUE_APP_S3_BUCKET}/${state.logo}` : undefined;
  },
}
